import { Component, OnInit, Input, HostListener, ElementRef, Output, EventEmitter, } from '@angular/core';
import { CitysListService } from './citys-list.service';
import { MessageService } from '../../core/services/message.service';
export interface FormCity {
  province_name: string;
  city_name: string
}
@Component({
  selector: 'app-citys-list',
  templateUrl: './citys-list.component.html',
  styleUrls: ['./citys-list.component.scss']
})
export class CitysListComponent implements OnInit {
  public formCity: FormCity[] = [
  ]
  @Input() selectCity: string; //发送选中的城市
  public citysList: Array<any> = []; //市；
  public addrList: Array<any> = []; //地址；
  public showCity: string = '';//显示信息
  public isOpen: boolean = false;//下拉框打开和闭合
  activeProvince = null;
  public placeHolder: string = "请选择期望城市(最多5个城市)";
  @Output() selectedCity: any = new EventEmitter(); //返回选中数据
  constructor(
    private _citysService: CitysListService,
    private _msg: MessageService,
    private el: ElementRef
  ) { }
  //下拉框隐藏
  @HostListener('body:click', ['$event'])
  onClick(event: any) {

    if (!this.el.nativeElement.contains(event.target)) {

      this.isOpen = false;
    }
  }
  getCityNames() {
    if (this.formCity.length === 0) { return this.placeHolder };
    let tmp = this.formCity.map(rec => {
      return rec.city_name;
    });
    if (tmp.length > 3) {
      return tmp.slice(0, 3).join(',') + `等${tmp.length}个城市`;
    } else {
      return tmp.join(',');
    }
  }
  ngOnInit() {
    //获取城市列表
    this.CitysList();
    setTimeout(() => {
      // console.log("this.selectCity", this.selectCity);
      if (this.selectCity) {
        let ss = this.selectCity.split(",");
        ss.map(rec => {
          this.formCity.push({ province_name: "", city_name: rec, });
        })
      }
      this.getCityNames();
    }, 300);


  }
  // 点击省份名称
  clickProvince(item) {
    this.activeProvince = item;
    this.citysList = item.children;
  }
  //选择城市数据
  selectedData(item) {
    let a = this.formCity.findIndex(rec => rec.city_name === item.name);
    if (a !== -1) {
      this.formCity.splice(a, 1);
    } else {
      if (this.formCity.length >= 5) {
        this._msg.warn('最多只能选择5个城市！');
        return false;
      }
      this.formCity.push({ province_name: this.activeProvince.name, city_name: item.name });
    }
  }

  //删除数据
  delect(event) {
    let tmp = this.formCity.findIndex(rec => rec.city_name == event.city_name);
    if (tmp !== -1) {
      this.formCity.splice(tmp, 1);
    }
    setTimeout(() => {
      this.isOpen = true;
    }, 10);
  }
  cancel() { // 取消选择
    this.formCity = [];
    if (this.selectCity) {
      let ss = this.selectCity.split(",");
      ss.map(rec => {
        this.formCity.push({ province_name: "", city_name: rec, });
      })
    }
    this.isOpen = !this.isOpen;
  }
  selectedJob() { // 确定选择数据
    let tmp = this.formCity.map(rec => {
      return rec.city_name;
    });
    this.selectedCity.emit(tmp.join(','));
    this.isOpen = !this.isOpen;
  }

  //打开城市选择框
  openListOpeion() {
    this.isOpen = !this.isOpen;
  }
  //设置样式
  setClass(event, level) {

    return { 'li-active': this.isSelected(event, level) };

  }
  isSelected(event, level) {
    return this.formCity.find(rec => {
      if (level == 1) {
        return rec.province_name === event.name;
      }
      if (level == 2) {
        return rec.city_name === event.name;
      }
    });
  }



  //最多选择5个
  maxList() {
    if (this.formCity.length >= 5) {
      this._msg.warn("最多只能选择5个城市！");
      setTimeout(() => { this._msg.clear(); }, 3000);
      return false;
    }
    return true
  }
  //获取城市列表
  CitysList() {
    this._citysService.getCitysList().then(resp => {
      if (resp.success) {
        this.addrList = resp['data'];
        // console.log(this.addrList);
      }
    })
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/user/citys-list/citys-list.component.ts